export default function Pagination({ pagination, onPageChange }) {
  if (!pagination || pagination.pages <= 1) return null;

  const { page, pages } = pagination;

  const getPages = () => {
    const windowStart = Math.max(2, page - 1);
    const windowEnd = Math.min(pages - 1, page + 1);
    const list = [1];

    if (windowStart > 2) list.push("...");

    for (let i = windowStart; i <= windowEnd; i += 1) {
      list.push(i);
    }

    if (windowEnd < pages - 1) list.push("...");
    if (pages > 1) list.push(pages);

    return list.filter((item, index, arr) => {
      if (item === "...") {
        return index === 0 || arr[index - 1] !== "...";
      }

      return arr.indexOf(item) === index;
    });
  };

  return (
    <div className="pagination">
      <button onClick={() => onPageChange(page - 1)} disabled={page === 1}>
        ‹
      </button>
      {getPages().map((p, i) =>
        p === "..." ? (
          <span key={`ellipsis-${i}`} style={{ padding: "0 4px", color: "#9ca3af" }}>
            …
          </span>
        ) : (
          <button
            key={`page-${p}`}
            className={page === p ? "active" : ""}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        ),
      )}
      <button onClick={() => onPageChange(page + 1)} disabled={page === pages}>
        ›
      </button>
    </div>
  );
}
